const useAttachFilesSummary = () => {
  const isAttachFilesSummaryEnabled = () => {
    try {
      const enabled =
        localStorage.getItem('console/attach-files-summary-enabled') || 'true';

      return enabled === 'true';
    } catch {
      return true;
    }
  };

  const toggleAttachFilesSummary = () => {
    try {
      localStorage.setItem(
        'console/attach-files-summary-enabled',
        (!isAttachFilesSummaryEnabled()).toString()
      );
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  };

  return {
    isAttachFilesSummaryEnabled,
    toggleAttachFilesSummary,
  };
};

export default useAttachFilesSummary;
